/* @jsx h */
import { labels } from '../../config';

const MapAlternativePagination = ({
  listCount,
  itemsPerPage,
  currentPage,
  setCurrentPage,
}) => {
  function handleLoadMoreClick() {
    setCurrentPage(currentPage + 1);
  }

  /* Only show load more button, if there is something to load */
  if (currentPage * itemsPerPage > listCount) {
    return '';
  }

  return (
    <div className="search-result__load-more">
      <button
        className="styled-button styled-button--load-more"
        type="button"
        onClick={handleLoadMoreClick}
      >
        <span>{labels.pagination.loadMore}</span>
      </button>
    </div>
  );
};

export default MapAlternativePagination;
